import { Component, Input } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { SigningStatus } from '@models/annual-statements/annual-statement-enums';

const signingStatusLabels: Record<SigningStatus, string> = {
  [SigningStatus.ReadyToSend]: 'Ready to Send',
  [SigningStatus.Created]: 'Sent',
  [SigningStatus.Sent]: 'Sent',
  [SigningStatus.Signed]: 'Signed',
  [SigningStatus.MarkedAsSigned]: 'Marked as Signed',
  [SigningStatus.MarkedAsSent]: 'Marked as Sent',
  [SigningStatus.Rejected]: 'Rejected',
  [SigningStatus.SentViaEmail]: 'Sent via Email',
};

@Component({
  selector: 'app-ag-document-signing-status',
  standalone: true,
  imports: [],
  templateUrl: 'ag-document-signing-status.component.html',
  styleUrl: 'ag-document-signing-status.component.scss'
})
export class AgDocumentSigningStatusComponent implements ICellRendererAngularComp {
  @Input() status: SigningStatus | null = SigningStatus.ReadyToSend;

  readonly SigningStatus = SigningStatus;
  readonly signingStatusLabels = signingStatusLabels;

  agInit(params: ICellRendererParams): void {
    this.status = params.value as number;
  }

  refresh(params: ICellRendererParams): boolean {
    this.status = params.value as number;
    return true;
  }
}
